import React from 'react';
import s from './LoadingSpinner.module.scss';

interface LoadingSpinnerProps {}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = () => {
  return (
    <div 
      className={s.loadingSpinner} 
      role="status"
      aria-label="Loading"
    />
  );
};

export default LoadingSpinner;
